import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';

import { DialogComponent, ButtonPropsModel, AnimationSettingsModel } from '@syncfusion/ej2-angular-popups';
import { ButtonModel } from '@syncfusion/ej2-angular-buttons';
import {KnockoutFieldModel} from "../../core/components/knockout-field/knockout-field.model";
import {
  Column,
  FilterService,
  FilterSettings,
  PageService,
  PageSettingsModel,
  SortService
} from "@syncfusion/ej2-angular-grids";
import {FilterSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";
import {TableGridFilterBarTemplate} from "../../core/components/data-grids/table-grid/table-grid-filter-bar-template";
import {DropDownList} from "@syncfusion/ej2-angular-dropdowns";
import {parentsUntil} from "@syncfusion/ej2-grids";
import {GridComponent} from "@syncfusion/ej2-angular-grids/src/grid/grid.component";
import {ToolbarSettingsModel} from "@syncfusion/ej2-richtexteditor/src/rich-text-editor/models/models";
import {EmojiPickerService, ToolbarType} from "@syncfusion/ej2-angular-richtexteditor";


@Component({
  selector: 'sb-scratch-page',
  templateUrl: './scratch-page.component.html',
  styleUrls: ['./scratch-page.component.scss'],
  providers: [PageService,
    SortService,
    FilterService,
    EmojiPickerService]
})
export class ScratchPageComponent {

  materialDefinition: KnockoutFieldModel = {
    name: "Material",
    i18nKey: "Material",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: true,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'home', displayValue: 'Home', i18nKey: 'Home'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "icon",
    rendererProperties: {
      "mi": "true"
    },
  };

  faDefinition: KnockoutFieldModel = {
    name: "FontAwesome",
    i18nKey: "Font Awesome",
    datatype: 'choice',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: true,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: {value: 'home', displayValue: 'Home', i18nKey: 'Home'},
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "icon",
    rendererProperties: {},
  };

  tinyField: KnockoutFieldModel = {
    name: "TinyMCE5",
    i18nKey: "TinyMCE5",
    datatype: 'text',
    availableValues: [],
    referenceTable: null,
    readonly: false,
    mandatory: false,
    enablePreview: false,
    tooltip: null,
    data: {
      defaultValue: null,
      defaultValueSource: 'script', // 'nlu' | 'function' | 'question' | 'script'; // Note: script also implies it is a constant
      answer: null, // null | {value?: string, displayValue?: string };
    },
    requestId: null,
    table: 'SyntheticTable',
    renderer: "html",
    rendererProperties: {
      "inline.editor": "false",
      "basic.toolbar": "false",
      // "editor.mode": "sync"
    },
  };

  toolbarSettings: ToolbarSettingsModel = {
    enable: true,
    enableFloating: false,
    type: ToolbarType.Scrollable,
    items: [

      // FullScreen
      "FullScreen",

      // Text
      "|",
      "Bold",
      "Italic",
      "Underline",
      "Formats",
      "FontSize",
      "FontColor",
      "BackgroundColor",
      "EmojiPicker",
    ],
  };

  @ViewChild("iconGrid")
  iconGrid: GridComponent;

  iconData: any[] = [];

  iconPageSettings: PageSettingsModel = {
    pageSize: 20,
  };

  iconFilterSettings: FilterSettingsModel = {
    type: 'FilterBar',
    mode: 'Immediate',
    ignoreAccent: true,
    immediateModeDelay: 500,
    enableCaseSensitivity: false,
  };

  iconColumnFilter = {
    operator: "contains",
  };

  filterBarTemplate: TableGridFilterBarTemplate = {
    create: (args: { element: Element, column: Column }) => {
      this.filterBarTemplate.elem = document.createElement('div');
      return this.filterBarTemplate.elem;
    },
    write: (args: { element: Element, column: Column }) => {
      this.filterBarTemplate.component = new DropDownList({
        dataSource: [
          { text: "Yes", value: true },
          { text: "No", value: false },
        ],
        floatLabelType: 'Never',
        allowFiltering: false,
        showClearButton: true,
        change: (args) => {
          let target: any = parentsUntil(args.element, 'e-filtertext');
          let columnName : string = target.id.replace('_filterBarcell', '');
          if (args.value) {
            this.iconGrid.filterByColumn(columnName, 'equal', args.value === "Yes");
          } else {
            this.iconGrid.removeFilteredColsByField(columnName);
          }
        },
      });
      this.filterBarTemplate.component.appendTo(this.filterBarTemplate.elem);
    }
  };

  iconsUsed = [
    "angle-right",
    "arrow-circle-left",
    "arrow-down",
    "arrow-right",
    "arrow-up",
    "asterisk",
    "backward",
    "ban",
    "bar-chart-o",
    "bolt",
    "book",
    "bookmark-o",
    "bullhorn",
    "calendar",
    "calendar-o",
    "caret-down",
    "caret-right",
    "caret-square-o-left",
    "caret-square-o-right",
    "chain-broken",
    "check",
    "check-circle",
    "check-circle-o",
    "check-square",
    "check-square-o",
    "chevron-down",
    "chevron-left",
    "chevron-right",
    "circle",
    "circle-thin",
    "clock-o",
    "cloud",
    "cloud-upload",
    "code",
    "code-fork",
    "codepen",
    "cog",
    "cogs",
    "comment",
    "comment-o",
    "comments-o",
    "copy",
    "cube",
    "cubes",
    "database",
    "desktop",
    "dollar",
    "download",
    "edit",
    "ellipsis-h",
    "envelope",
    "envelope-o",
    "exchange",
    "exclamation",
    "exclamation-circle",
    "exclamation-triangle",
    "external-link",
    "eye",
    "file-code-o",
    "file-pdf-o",
    "file-text-o",
    "files-o",
    "film",
    "filter",
    "flask",
    "gavel",
    "gears",
    "github",
    "globe",
    "hand-o-left",
    "history",
    "info-circle",
    "key",
    "language",
    "level-up",
    "link",
    "list",
    "list-alt",
    "lock",
    "long-arrow-down",
    "long-arrow-right",
    "long-arrow-up",
    "minus",
    "mobile",
    "paperclip",
    "pause",
    "pencil",
    "phone",
    "plus",
    "plus-square-o",
    "question",
    "question-circle",
    "random",
    "refresh",
    "rss",
    "search",
    "search-minus",
    "search-plus",
    "send",
    "share-alt",
    "sitemap",
    "sort",
    "square",
    "square-o",
    "stop",
    "table",
    "text-width",
    "th-large",
    "thumb-tack",
    "times",
    "times-circle",
    "trash",
    "trash-o",
    "university",
    "unlock-alt",
    "user",
    "users",
    "warning",
    "wrench"
  ];

  constructor() { }
  async ngOnInit() {

    // Wipe out the page context
    (window as any).KO_PAGE_CONTEXT.clear();

    // Wipe out the Knockout content.
    const pageContentMain = document.getElementById("page-content-main");
    if (pageContentMain) {
      pageContentMain.innerHTML = "";
    }
    const errorConsole = document.getElementById("error-console");
    if (errorConsole) {
      errorConsole.innerHTML = "";
    }

    const miResult = await fetch('/scripts/assets/icons/material-symbols-outlined-names.json');
    const miJson: string[] = await miResult.json(); // _

    const faResult = await fetch('/scripts/assets/icons/font-awesome-names.json');
    const faJson: string[] = await faResult.json(); // -

    const allNames = [...new Set([...miJson, ...faJson])].sort();

    const data = allNames.map(n => {
      const underName = n.replace(/-/g, '_');
      const includeMI = miJson.includes(n) && underName.includes("_");
      return {
        name: n + (includeMI ? `, ${underName}` : ''),
        mi: miJson.includes(n) ? `<i class="mi" style="font-size: 24px">${n}</i>` : "",
        fa: faJson.includes(n) ? `<i class="fa fa-${n}" style="font-size: 24px"></i>` : "",
        used: this.iconsUsed.includes(n)
      };
    });

    this.iconData = data;
  }


  // EXAMPLE MODAL

  @ViewChild('Dialog') public Dialog: DialogComponent;

  public showModal = (): void => {
    this.Dialog.show();
  }

  public hideModal = (): void => {
    this.Dialog.hide();
  }

  public modalActions: { [key: string]: ButtonModel }[] = [
    {
      buttonModel: { content: 'Cancel' },
      click: this.hideModal.bind(this),
    },
    {
      buttonModel: { content: 'Save filter', isPrimary: true },
      click: this.hideModal.bind(this),
    },
  ];

}
